import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';

import { of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FeatureResolver implements Resolve<any> {
  constructor(private _router: Router, private runTimeConfigService: RunTimeConfigService, private http: HttpClient) {}

  resolve(route: ActivatedRouteSnapshot) {
    const app = this.runTimeConfigService
      .getConfig('featuresConfig')
      .globalFeatures.apps.find(i => i.app === route.data['app']);

    // app has features config
    if (app && app.featuresConfig) {
      return this.runTimeConfigService.getAppSpecificFeatures(app.featuresConfig).pipe(
        map(appFeatures => appFeatures),
        catchError(err => throwError(err.json().error))
      );
    } else {
      return of({});
    }
  }
}
